export default __webpack_public_path__ + "static/media/no_history.f205eeca.png";